/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const DistanceShippingFeePage = lazyLoad(
  () => import('./index'),
  module => module.DistanceShippingFeePage
);
